import(/* webpackMode: "eager" */ "/codebuild/output/src1855149980/src/comici-magazine/src/app/(app)/error.tsx");
